import React from 'react'
import classnames from 'classnames/bind'
import styles from './Eyebrow.module.css'

const cx = classnames.bind(styles)

export type EyebrowVariant = 'reward' | 'muted' | 'field' | 'stat' | 'statHero'
export type EyebrowAs = 'span' | 'h2' | 'p' | 'dt'

export interface EyebrowProps {
  variant?: EyebrowVariant
  as?: EyebrowAs
  className?: string
  children: React.ReactNode
  id?: string
}

const Eyebrow: React.FC<EyebrowProps> = ({
  variant = 'reward',
  as: Component = 'span',
  className,
  children,
  id
}) => (
  <Component className={cx('eyebrow', variant, className)} id={id}>
    {children}
  </Component>
)

export default Eyebrow
